import React, { useContext, useEffect, useState } from "react";

import { TermsContext } from "../../../utils/Context";
import { MULTI, SINGLE, Selector } from "../../Selectors/Selector";
import { sortTermsAscending } from "../utils";

export const TermSelect = ({
  selectHandler,
  selectedAcademicYears,
  noFutureTerms = false,
  noDefaultTerm = false,
  clear,
  selectedTerms,
  isSingle,
  label,
  id,
  size,
  filteredTermIds,
}) => {
  const { insightsTerms } = useContext(TermsContext);
  const [options, setOptions] = useState([]);

  useEffect(() => {
    let insightsTermsList = [];

    if (selectedAcademicYears?.length > 0) {
      selectedAcademicYears.forEach((year) => {
        insightsTermsList = insightsTermsList.concat(year.insights_terms);
      });
    } else {
      insightsTermsList = insightsTerms.filter(
        (term) => !!term.canvas_terms && term.canvas_terms.length > 0
      );
    }

    const currentDate = new Date();

    if (noFutureTerms) {
      insightsTermsList = insightsTermsList.filter((term) => {
        const sortedCanvasTerms = sortTermsAscending(term.canvas_terms);
        // Finds the earliest canvas term with a valid start date
        const earliestCanvasTerm = sortedCanvasTerms.find(
          (term) => !!term.start_at
        );

        if (!earliestCanvasTerm) return false;

        const itemDate = new Date(earliestCanvasTerm.start_at);
        return itemDate <= currentDate;
      });
    }
    if (filteredTermIds && filteredTermIds.length > 0) {
      insightsTermsList = insightsTermsList.filter((term) =>
        filteredTermIds.includes(term.id)
      );
    }
    if (noDefaultTerm) {
      insightsTermsList = insightsTermsList.filter(
        (term) => term.start_at !== "default"
      );
    }

    setOptions(
      insightsTermsList
        .sort((a, b) => {
          const aIsDefault = a.start_at === "default";
          const bIsDefault = b.start_at === "default";

          if (aIsDefault && !bIsDefault) return -1;

          if (!aIsDefault && bIsDefault) return 1;

          return new Date(a.start_at) - new Date(b.start_at);
        })
        .map((term) => ({ ...term, label: term.name }))
    );
  }, [insightsTerms, selectedAcademicYears, noFutureTerms, filteredTermIds]);

  return (
    <Selector
      type={isSingle ? SINGLE : MULTI}
      id={id || "term-select"}
      label={label}
      options={options}
      selectHandler={selectHandler}
      clear={clear}
      size={size}
      selectedOptions={!isSingle ? selectedTerms : null}
      selectedItemId={isSingle ? selectedTerms : null}
    />
  );
};
